import React from 'react'

function Icon({ name, ...props }) {

    return (
        <i className={name} {...props} ></i>
    )
}

export default Icon